/* eslint-disable */

import React from "react";

import {
  ScreenHeader,
  ScreenContainer,
  Container,
} from "../../components/wombat-ui";
import {
  H2,
  H3,
  P,
  UList,
} from "../../components/wombat-ui/components/Typography";

const PrivacyPolicy = () => {
  return (
    <>
      <ScreenHeader narrow title={"Politique de respect et traitement des données"} />
      <Container narrow>
        <H2>MOOVEO</H2>

        <P>
          La présente politique vise à vous informer de la collecte,
          l'utilisation et du partage de vos informations personnelles à
          l’occasion de l’utilisation de nos services.
        </P>

        <H3>Objet</H3>

        <P>
          Les présentes clauses ont pour objet de définir les conditions dans
          lesquelles le sous-traitant s’engage à effectuer pour le compte du
          responsable de traitement les opérations de traitement de données à
          caractère personnel définies ci-après.
        </P>

        <P>
          Dans le cadre de leurs relations contractuelles, les parties
          s’engagent à respecter la règlementation en vigueur applicable au
          traitement de données à caractère personnel et, en particulier, le
          règlement (UE) 2016/679 du Parlement européen et du Conseil du 27
          avril 2016 applicable à compter du 25 mai 2018 (ci-après, « le
          règlement européen sur la protection des données »).
        </P>

        <H3>Description du traitement faisant l’objet de la sous-traitance</H3>

        <P>
          Le sous-traitant est autorisé à traiter pour le compte du responsable
          de traitement les données à caractère personnel nécessaires pour
          fournir le ou les service(s) suivant(s) :
        </P>

        <UList
          items={[
            "Mooveo, outil de suivi des collaborateurs en entrerprises",
          ]}
        />

        <P>
          La nature des opérations réalisées sur les données correspond à la
          collecte et l’analyse. La finalité́ du traitement est l’assistance de
          la gestion des ressources humaines.
        </P>

        <P>
          Les données à caractère personnel traitées sont le nom, le prénom, le
          titre, l’adresse, la fonction et les informations liées à l’activité
          professionnelle.
        </P>

        <P>
          Les catégories de personnes concernées sont les collaborateurs et
          salariés de nos clients professionnels.
        </P>

        <P>
          Pour l’exécution du service objet du présent contrat, le responsable
          de traitement met à la disposition du sous-traitant les informations
          nécessaires à la bonne exécution des services.
        </P>

        <H3>Durée du contrat</H3>

        <P>
          Le présent contrat entre en vigueur à compter de la date de début du
          présent contrat pour une durée d’un (1) an, reconduit par tacite
          reconduction.
        </P>

        <H3>
          Obligations du sous-traitant vis-à-vis du responsable de traitement
        </H3>

        <P>Le sous-traitant s'engage à :</P>

        <P>
          Traiter les données uniquement pour la ou les seule(s) finalité́(s) qui
          fait/font l’objet de la sous-traitance
        </P>

        <P>
          Traiter les données conformément aux instructions documentées du
          responsable de traitement figurant en annexe du présent contrat. Si le
          sous-traitant considère qu’une instruction constitue une violation du
          règlement européen sur la protection des données ou de toute autre
          disposition du droit de l’Union ou du droit des États membres relative
          à la protection des données, il en informe immédiatement le
          responsable de traitement. En outre, si le sous-traitant est tenu de
          procéder à un transfert de données vers un pays tiers ou à une
          organisation internationale, en vertu du droit de l’Union ou du droit
          de l’État membre auquel il est soumis, il doit informer le responsable
          du traitement de cette obligation juridique avant le traitement, sauf
          si le droit concerné interdit une telle information pour des motifs
          importants d'intérêt public
        </P>

        <P>
          Garantir la confidentialité́ des données à caractère personnel traitées
          dans le cadre du présent contrat
        </P>

        <P>
          Veiller à ce que les personnes autorisées à traiter les données à
          caractère personnel en vertu du présent contrat :
        </P>

        <UList
          items={[
            "S’engagent à respecter la confidentialité́ ou soient soumises à une obligation légale appropriée de confidentialité́",
            "Reçoivent la formation nécessaire en matière de protection des données à caractère personnel",
          ]}
        />

        <P>
          Prendre en compte, s’agissant de ses outils, produits, applications ou
          services, les principes de protection des données dès la conception et
          de protection des données par défaut
        </P>

        <P>Sous-traitance</P>

        <P>
          Le sous-traitant peut faire appel à un autre sous-traitant (ci-après,
          « le sous-traitant ultérieur ») pour mener des activités de traitement
          spécifiques. Dans ce cas, il informe préalablement et par écrit le
          responsable de traitement de tout changement envisagé concernant
          l’ajout ou le remplacement d’autres sous-traitants. Cette information
          doit indiquer clairement les activités de traitement sous-traitées,
          l’identité́ et les coordonnées du sous-traitant et les dates du contrat
          de sous-traitance. Le responsable de traitement dispose d’un délai
          minium d’un (1) mois à compter de la date de réception de cette
          information pour présenter ses objections. Cette sous-traitance ne
          peut être effectuée que si le responsable de traitement n'a pas émis
          d'objection pendant le délai convenu.
        </P>

        <P>
          Le sous-traitant ultérieur est tenu de respecter les obligations du
          présent contrat pour le compte et selon les instructions du
          responsable de traitement. Il appartient au sous-traitant initial de
          s’assurer que le sous-traitant ultérieur présente les mêmes garanties
          suffisantes quant à la mise en œuvre de mesures techniques et
          organisationnelles appropriées de manière à ce que le traitement
          réponde aux exigences du règlement européen sur la protection des
          données. Si le sous-traitant ultérieur ne remplit pas ses obligations
          en matière de protection des données, le sous-traitant initial demeure
          pleinement responsable devant le responsable de traitement de
          l’exécution par l’autre sous-traitant de ses obligations.
        </P>

        <H3>Droit d’information des personnes concernées</H3>

        <P>
          Il appartient au responsable de traitement de fournir l’information
          aux personnes concernées par les opérations de traitement au moment de
          la collecte des données.
        </P>

        <H3>Exercice des droits des personnes</H3>

        <P>
          Dans la mesure du possible, le sous-traitant doit aider le responsable
          de traitement à s’acquitter de son obligation de donner suite aux
          demandes d’exercice des droits des personnes concernées : droit
          d’accès, de rectification, d’effacement et d’opposition, droit à la
          limitation du traitement, droit à la portabilité́ des données, droit de
          ne pas faire l’objet d’une décision individuelle automatisée (y
          compris le profilage).
        </P>

        <P>
          Lorsque les personnes concernées exercent auprès du sous-traitant des
          demandes d’exercice de leurs droits, le sous-traitant doit adresser
          ces demandes des réceptions par courrier électronique au contact
          désigné par le responsable de traitement.
        </P>

        <H3>Notification des violations de données à caractère personnel</H3>

        <P>
          Le sous-traitant notifie au responsable de traitement toute violation
          de données à caractère personnel dans un délai maximum de 24 heures
          après en avoir pris connaissance et par voie électronique. Cette
          notification est accompagnée de toute documentation utile afin de
          permettre au responsable de traitement, si nécessaire, de notifier
          cette violation à l’autorité́ de contrôle compétent.
        </P>

        <H3>
          Aide du sous-traitant dans le cadre du respect par le responsable de
          traitement de ses obligations
        </H3>

        <P>
          Le sous-traitant aide le responsable de traitement pour la réalisation
          d’analyses d’impact relative à la protection des données.
        </P>

        <P>
          Le sous-traitant aide le responsable de traitement pour la réalisation
          de la consultation préalable de l’autorité́ de contrôle.
        </P>

        <H3>Mesures de sécurité</H3>

        <P>
          Le sous-traitant s’engage à mettre en œuvre les mesures de sécurité
          suivantes :
        </P>

        <UList
          items={[
            "Les moyens permettant de garantir la confidentialité, l'intégrité, la disponibilité et la résilience constantes des systèmes et des services de traitement",
            "Les moyens permettant de rétablir la disponibilité des données à caractère personnel et l'accès à celles-ci dans des délais appropries en cas d'incident physique ou technique",
            "Une procédure visant à tester, à analyser et à évaluer régulièrement l'efficacité des mesures techniques et organisationnelles pour assurer la sécurité du traitement",
          ]}
        />

        <H3>Sort des données</H3>

        <P>
          Au terme de la prestation de services relatifs au traitement de ces
          données, le sous-traitant s’engage à :
        </P>
        <P>Au choix des parties :</P>

        <UList
          items={[
            "Détruire toutes les données à caractère personnel où",
            "À renvoyer toutes les données à caractère personnel au responsable de traitement où",
            "À renvoyer les données à caractère personnel au sous-traitant désigné par le responsable de traitement",
          ]}
        />

        <P>
          Le renvoi doit s’accompagner de la destruction de toutes les copies
          existantes dans les systèmes d’information du sous-traitant. Une fois
          détruites, le sous-traitant doit justifier par écrit de la
          destruction.
        </P>

        <H3>Registre des catégories d’activités de traitement</H3>

        <P>
          Le sous-traitant déclare tenir par écrit un registre de toutes les
          catégories d’activités de traitement effectuées pour le compte du
          responsable de traitement comprenant :
        </P>

        <UList
          items={[
            "Le nom et les coordonnées du responsable de traitement pour le compte duquel il agit, des éventuels sous-traitants et, le cas échéant, du délègué à la protection des données",
            "Les catégories de traitements effectuent pour le compte du responsable du traitement",
            "Le cas échéant, les transferts de données à caractère personnel vers un pays tiers ou à une organisation internationale, y compris l'identification de ce pays tiers ou de cette organisation internationale et, dans le cas des transferts vises à l'article 49, paragraphe 1, deuxième alinéa du règlement européen sur la protection des données, les documents attestant de l'existence de garanties appropriées",
          ]}
        />

        <H3>Documentation</H3>

        <P>
          Le sous-traitant met à la disposition du responsable de traitement la
          documentation nécessaire pour démontrer le respect de toutes ses
          obligations et pour permettre la réalisation d'audits, y compris des
          inspections, par le responsable du traitement ou un autre auditeur
          qu'il a mandaté, et contribuer à ces audits.
        </P>

        <H3>
          Obligations du responsable de traitement vis-À-vis du sous-traitant
        </H3>

        <P>Le responsable de traitement s’engage à :</P>

        <UList
          items={[
            "Fournir au sous-traitant les données visées au II des présentes clauses",
            "Documenter par écrit toute instruction concernant le traitement des données par le sous- traitant",
            "Veiller, au préalable et pendant toute la durée du traitement, au respect des obligations prévues par le règlement européen sur la protection des données de la part du sous-traitant",
            "Superviser le traitement, y compris réaliser les audits et les inspections auprès du sous- traitant",
          ]}
        />
      </Container>
    </>
  );
};

export default PrivacyPolicy;
